import { SET_TITLE, SET_SUB_TITLE } from "../types";

const initialState = {
  title: "Wheel Name Placeholder",
  subtitle: "Subtitle",
};

const builderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TITLE:
      return {
        ...state,
        title: action.payload,
      };
    case SET_SUB_TITLE:
      return {
        ...state,
        subtitle: action.payload,
      };
    default:
      return state;
  }
};

export default builderReducer;
